(() => {
  const wizard = () => document.querySelector('trade-in-wizard');
  const launcher = () => wizard()?.shadowRoot?.querySelector('[part="launcher"]');

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey ||
        event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') ||
        (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.href);

    // "#trade-in" opens the wizard where it starts (category picker).
    if (url.hash === '#trade-in') {
      const button = launcher();
      if (!button) return;
      event.preventDefault();
      button.click();
      return;
    }

    const category = url.searchParams.get('ti_cat')?.trim();
    // endsWith: "/pages/verkaufen" also matches the localized "/fr/pages/verkaufen".
    if (!category || url.origin !== location.origin || !location.pathname.endsWith(url.pathname) || url.hash) return;
    if ([...url.searchParams.keys()].some((key) => key.startsWith('ti_') && key !== 'ti_cat')) return;

    const request = new CustomEvent('revendo:trade-in:open-picker', {
      cancelable: true,
      detail: { category },
    });
    document.dispatchEvent(request);
    if (request.defaultPrevented) event.preventDefault();
  });

  // Mobile sticky CTA: show once the hero section has scrolled out of view.
  // Observe the section, not <trade-in-wizard>: the app re-creates that node after upgrade.
  const sticky = document.querySelector('.shopify-section[id$="__revendo_sticky_cta"]');
  const hero = document.querySelector('.shopify-section[id$="__hero"]');
  if (!sticky || !hero || !('IntersectionObserver' in window)) return;

  // The bar is taller than 52px, so Tidio hides while it is visible, as on the PDP
  // (rule: .cursor/rules/design.mdc, «Schwebende Elemente»). Mobile only, like the bar.
  // An open chat stays; revendo:chat-closed (revendo-ui-tools.js) syncs afterwards.
  const mobile = window.matchMedia('(max-width: 749.98px)');
  const syncTidio = () => {
    const api = window.tidioChatApi;
    if (!api || !mobile.matches || document.body.classList.contains('rv-chat-open')) return;
    if (sticky.classList.contains('revendo-sticky-cta--on')) api.hide();
    else api.show();
  };
  document.addEventListener('tidioChat-ready', syncTidio);
  document.addEventListener('revendo:chat-closed', syncTidio);

  new IntersectionObserver(([entry]) => {
    sticky.classList.toggle('revendo-sticky-cta--on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    syncTidio();
  }).observe(hero);
})();
